import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import $window from './utils/window';

export default function PortalApp({ children }) {
  const [portalEl, setPortalEl] = useState(null);

  useEffect(() => {
    if ($window.dre20params && $window.dre20params.portal) {
      const el = document.querySelector(decodeURIComponent($window.dre20params.portal));
      if (el) {
        setPortalEl(el);
      } else {
        // eslint-disable-next-line no-console
        console.warn(
          `[PortalApp] Portal selector '${$window.dre20params.portal}' was set but no element was found. Falling back to default container.`
        );
      }
    }
  }, []);

  if (portalEl) {
    return ReactDOM.createPortal(children, portalEl);
  }
  return children;
} 